import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../../../interfaces/app-state.interface';
import {BelegSelectors} from '../../../store/selectors/beleg.selectors';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {combineLatest} from 'rxjs';
import {ErkennungsartDTO} from '../../../openapi/beleg-openapi';
import {BelegActions} from '../../../store/actions/beleg.actions';
import {take} from 'rxjs/operators';

@Component({
  selector: 'zlng-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
})
export class PreviewComponent implements OnInit {
  private _store = inject(Store<AppState>);
  private _destroyRef = inject(DestroyRef);

  public loading = false;

  private _blob?: Blob;

  get blob(): Blob | undefined {
    return this._blob;
  }

  private _isERechnung = false;

  get isERechnung(): boolean {
    return this._isERechnung;
  }

  private _highlightText = '';

  get highlightText(): string {
    return this._highlightText;
  }

  constructor() {}

  ngOnInit(): void {
    combineLatest([this._store.select(BelegSelectors.previewBelegDto), this._store.select(BelegSelectors.content)])
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(([belegDto, content]) => {
        if (!belegDto || !content) return;

        const base64string = content?.split(',')[1];
        const byteCharacters = atob(base64string);
        const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);

        // INFO: Mime-Type wird aus dem BelegDTO geholt
        let mimeType = belegDto.contentType || '';

        /*
         * INFO:
         * Bei XRechnung wird der Mime-Type bewusst auf application/pdf gesetzt,
         * da wir serverseitig ein PDF aus den Daten der XRechnung generieren.
         * Der 'contentType' ist dann ein PDF-Blob - der Mime-Type jedoch application/xml.
         */
        const erkennungsart = belegDto.erkennungsart;
        if (erkennungsart === ErkennungsartDTO.XRechnung) {
          mimeType = 'application/pdf';
        }

        this._blob = new Blob([byteArray], {type: mimeType});

        this._isERechnung =
          erkennungsart === ErkennungsartDTO.XRechnung
          || erkennungsart === ErkennungsartDTO.Zugferd
          || erkennungsart === ErkennungsartDTO.FakturierungPortal;
      });

    this._store
      .select(BelegSelectors.isLoading)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(loading => {
        this.loading = loading;
      });

    this._store
      .select(BelegSelectors.highlight)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(highlightText => {
        this._highlightText = highlightText;
      });
  }

  doDownloadBeleg() {
    this._store
      .select(BelegSelectors.previewBelegDto)
      .pipe(take(1))
      .subscribe(belegDto => {
        if (!belegDto) return;

        this._store.dispatch(BelegActions.downloadBeleg({belegDto}));
      });
  }
}
